import { FunctionComponent, useState } from 'react';
import VMABanner from './components/VMABanner';
import { useAlertMessages } from './statusService';
import { getSeenAlerts, setAlertAsSeen } from './vmaStorage';

const VMA: FunctionComponent = () => {
    const { response } = useAlertMessages();
    const [seenAlerts] = useState(getSeenAlerts());

    if (!response?.alertMessages) {
        return null;
    }

    return (
        <div>
            {response.alertMessages.map((status) => {
                if (seenAlerts.includes(status.alertMessageId)) {
                    return null;
                }

                return <VMABanner key={status.alertMessageId} {...status} onDismiss={setAlertAsSeen} />;
            })}
        </div>
    );
};

export default VMA;
